module.exports = __webpack_public_path__ + "static/thumb-8-7247dcedb31a2915b31097a95533a588.jpg";